import { useOrderStore } from '../modules/orders/store'
import { useStore } from '../store'

/**
 * Limpa todos os stores do Zustand para evitar que dados de um usuário
 * sejam mantidos quando outro usuário faz login no mesmo navegador
 */
export const clearAllStores = () => {
  try {
    // Limpa o store de orders
    const orderStore = useOrderStore.getState()
    if (orderStore?.resetForm) {
      orderStore.resetForm()
    }
    // Reseta o estado completo do orderStore
    useOrderStore.setState({
      form: {
        orderItems: [],
        installments: []
      },
      paymentStep: {},
      currentStep: '',
      currentOrderId: '',
      orderMode: 'view',
      productMode: 'view',
      selectedItem: {},
      orderListTotal: 0,
      search: '',
      orderFilters: {},
      orderProductListFilters: {},
      isEditItemOpen: false,
      opportunity: {},
      sequence: {},
      filtersForm: {},
      filters: { listMode: 'proposals' },
      isTaxesRecalculePending: false,
      sort: [
        {
          field: 'proposalId',
          sort: 'desc'
        }
      ]
    })

    // Limpa o store principal
    const mainStore = useStore.getState()
    if (mainStore?.resetProposalForm) {
      mainStore.resetProposalForm()
    }
    // Reseta o estado completo do mainStore
    useStore.setState({
      proposalForm: { stepOne: null, stepTwo: { products: [] } },
      currentStep: 0,
      isEditItemOpen: false,
      selectedItem: {},
      opportunity: {}
    })
  } catch (error) {
    console.error('Erro ao limpar stores:', error)
  }
}
